import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
    },
    iconActive: {
      color: palette.green,
      marginRight: 5,
      height: 15,
      width: 15,
      padding: 0,
    },
    iconCancel: {
      color: palette.red,
      marginRight: 5,
      height: 15,
      width: 15,
      padding: 0,
    },
    iconStarted: {
      marginRight: 5,
      height: 15,
      width: 15,
      padding: 0,
    },
  });
